module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/10e1ce9d33e5230ae40a.worker.js");
}
